import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

import CustomSelect from 'components/select';
import Translate from '../Translate';
import "./index.css"

const getPaginationRange = (curPage, numberOfPages, showPages) => {
  const pages = new Set();

  pages.add(0);
  pages.add(numberOfPages - 1);

  const half = Math.floor(showPages / 2);
  const start = Math.max(1, curPage - half);
  const end = Math.min(numberOfPages - 2, curPage + half);

  for (let i = start; i <= end; i++) {
    pages.add(i);
  }

  const sortedPages = Array.from(pages).sort((a, b) => a - b);
  return sortedPages;
};

const TablePagination = ({
                           showPages, numberOfPages, curPage, selectPage, handleChangeRowsPerPage, rowsPerPage, totalRows
                         }) => {
  const pageNumbers = getPaginationRange(curPage, numberOfPages, showPages);

  return (
      <div style={{
        padding: '15px', height: '70px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center',
      }}
      >
        <div className="centered-flex-container">
          <span style={{ marginRight: '5px' }}>({totalRows})</span>
          <span>
          <Translate text="rowsPerPage" />
        </span>
          <div style={{ width: '10px' }} />
          <CustomSelect
              wrapperStyles={{ width: '60px' }}
              handleSelect={handleChangeRowsPerPage}
              position="top"
              listStyles={{ boxShadow: 'none' }}
              selected={rowsPerPage}
              options={[{ value: 5, title: '5' }, { value: 10, title: '10' }, { value: 25, title: '25' }, { value: 50, title: '50' }]}
          />
        </div>
        <div style={{ width: '10px' }} />
        <div className="centered-flex-container">
          <button
              className="no-style-button right-arrow-icon"
              type="button"
              style={{ margin: '0 10px' }}
              disabled={curPage === 0}
              onClick={() => { selectPage(curPage - 1); }}
          />
          <ul className="no-style-list centered-flex-container" style={{ gap: '4px' }}>
            {pageNumbers.map((page, index) => {
              const prev = pageNumbers[index - 1];
              const showEllipsis = prev !== undefined && page - prev > 1;
              return (
                  <React.Fragment key={page}>
                    {showEllipsis && <li style={{ padding: '4px 8px' }}>...</li>}
                    <li
                        className={'page-number ' + (page === curPage ? 'page-number-selected' : '') }
                        onClick={() => { selectPage(page); }}
                    >
                      {page + 1}
                    </li>
                  </React.Fragment>
              );
            })}
          </ul>
          <button
              type="button"
              className="no-style-button left-arrow-icon"
              style={{ margin: '0 10px' }}
              disabled={curPage + 1 >= numberOfPages}
              onClick={() => { selectPage(curPage + 1); }}
          />
        </div>
      </div>
  );
};

TablePagination.propTypes = {
  numberOfPages: PropTypes.number,
  curPage: PropTypes.number,
  selectPage: PropTypes.func,
  showPages: PropTypes.number,
  handleChangeRowsPerPage: PropTypes.func,
  rowsPerPage: PropTypes.number,
  totalRows: PropTypes.number,
};

TablePagination.defaultProps = {
  showPages: 3,
  rowsPerPage: 5,
};

export default Radium(TablePagination);



// WEBPACK FOOTER //
// ./src/components/TablePagination/index.jsx